<template>
  <div class="patentList fatherHeight contBox">
    <div class="bar-title">挂号信息</div>
    <div>
      <div class="search-top">
        <el-form :inline="true" :model="searchData" ref="searchForm" :label-width="80" label-suffix=":">
          <el-form-item label="姓名">
            <el-input v-model="searchData.name" type="text" clearable placeholer="请输入"></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="searchData.cert_no" type="text" clearable placeholer="请输入"></el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-model="searchData.time" type="daterange"
              range-separator="-" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button @click="handleSearch" class="color-main" type="primary">
              <i class="fa fa-search"></i>查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="patientList" ref="tableBoxRef">
      <div class="list-top flex-between">
        <div class="bar-title">挂号列表</div>
        <el-button @click="addGhxx" class="color-main" type="primary" v-show="activeName == '2'">
          <i class="fa fa-plus-circle"></i>新增
        </el-button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="透析治疗" name="1">
          <div class="table">
            <el-table v-loading="dataListLoading" v-if="istable" :data="tableData" class="table-ellipsis" size="small"
              border :max-height="tableHei">
              <el-table-column type="index" label="序号" fixed width="60" align="center">
                <template #default="scope">
                  {{ (pageData.currentPage - 1) * pageData.pageSize + (scope.$index + 1) }}
                </template>
              </el-table-column>
              <el-table-column prop="schedule_date" fixed label="排班时间" show-overflow-tooltip width="120" />
              <el-table-column prop="nm_name" fixed align="center" label="班次" width="80">
                <template #default="scope">
                  <el-tag v-if="scope.row.nm_name == '上午'" type="primary" size="small">{{ scope.row.nm_name }}</el-tag>
                  <el-tag v-if="scope.row.nm_name == '下午'" type="warning" size="small">{{ scope.row.nm_name }}</el-tag>
                  <el-tag v-if="scope.row.nm_name == '晚上'" type="info" size="small">{{ scope.row.nm_name }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="bed_time" label="挂号时间" show-overflow-tooltip width="120" />
              <el-table-column label="挂号" align="center">
                <template #default="scope">
                  <el-tag effect="dark" type="success" v-if="scope.row.dict_status == '908120000'"
                    size="small">已挂号</el-tag>
                  <el-tag effect="dark" type="info"
                    v-if="scope.row.dict_status == '908110000' || scope.row.dict_status == '' || scope.row.dict_status == null"
                    size="small">未挂号</el-tag>
                  <el-tag effect="dark" type="danger" v-if="scope.row.dict_status == '908130000'"
                    size="small">已取消</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed label="姓名">
                <template #default="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="dict_sex_name" width="60" label="性别" align="center" show-overflow-tooltip />
              <el-table-column prop="age" width="60" label="年龄" align="center" show-overflow-tooltip />
              <el-table-column prop="admin_user_name" label="挂号医生" align="center" show-overflow-tooltip />
              <el-table-column prop="dept_name" label="挂号科室" align="center" show-overflow-tooltip />
              <el-table-column label="结算类别" width="80" align="center">
                <template #default="scope">
                  <el-tag type="warning" v-if="scope.row.dict_pay_cate == '1001'" size="small">自费</el-tag>
                  <el-tag type="success" v-if="scope.row.dict_pay_cate == '4040'" size="small">医保</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="结算状态" width="100" align="center">
                <template #default="scope">
                  <el-tag type="info" v-if="scope.row.upload_settle == '0'" size="small">未结算</el-tag>
                  <el-tag type="success" v-if="scope.row.upload_settle == '1'" size="small">已结算</el-tag>
                  <el-tag type="danger" v-if="scope.row.upload_settle == '2'" size="small">已撤销</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120" align="center">
                <template #default="scope">
                  <el-link type="primary" @click="registClick(scope.row)"
                    v-if="scope.row.dict_status == '908110000' || scope.row.dict_status == '908130000' || scope.row.dict_status == '' || scope.row.dict_status == null">
                    挂号
                  </el-link>
                  <el-link type="danger" @click="caseClick(scope.row)" v-if="scope.row.dict_status == '908120000'">
                    取消
                  </el-link>
                  <!-- <el-link type="primary" @click="modParient(scope.row)" v-if="scope.row.dict_status == '908120000'">修改</el-link> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination :currentPage="pageData.currentPage" :page-size="pageData.pageSize"
                :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
                :total="pageData.totalSum" @size-change="handleSizeChange"
                @current-change="handleCurrentChange"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="普通门诊" name="2">
          <div class="table">
            <el-table v-loading="dataListLoading1" v-if="istable" :max-height="tableHei" :data="tableData2"
              class="table-ellipsis" size="small" border>
              <el-table-column type="index" label="序号" fixed width="60" align="center">
                <template #default="scope">
                  {{ (pageData2.currentPage - 1) * pageData2.pageSize + (scope.$index + 1) }}
                </template>
              </el-table-column>
              <el-table-column prop="bed_time" fixed label="挂号时间" />
              <el-table-column fixed label="挂号" align="center">
                <template #default="scope">
                  <el-tag effect="dark" type="success" v-if="scope.row.dict_status == '908120000'"
                    size="small">已挂号</el-tag>
                  <el-tag effect="dark" type="info"
                    v-if="scope.row.dict_status == '908110000' || scope.row.dict_status == '' || scope.row.dict_status == null"
                    size="small">未挂号</el-tag>
                  <el-tag effect="dark" type="danger" v-if="scope.row.dict_status == '908130000'"
                    size="small">已取消</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed label="姓名">
                <template #default="scope">
                  {{ scope.row.patient_name }}
                </template>
              </el-table-column>
              <el-table-column prop="dict_sex_name" width="60" label="性别" align="center" />
              <el-table-column prop="age" width="60" label="年龄" align="center" />
              <el-table-column prop="admin_user_name" label="挂号医生" align="center" show-overflow-tooltip />
              <el-table-column prop="dept_name" label="挂号科室" align="center" show-overflow-tooltip />
              <el-table-column label="结算类别" width="100" align="center">
                <template #default="scope">
                  <el-tag type="warning" v-if="scope.row.dict_pay_cate == '1001'" size="small">自费</el-tag>
                  <el-tag type="success" v-if="scope.row.dict_pay_cate == '4040'" size="small">医保</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="结算状态" width="100" align="center">
                <template #default="scope">
                  <el-tag type="info" v-if="scope.row.upload_settle == '0'" size="small">未结算</el-tag>
                  <el-tag type="success" v-if="scope.row.upload_settle == '1'" size="small">已结算</el-tag>
                  <el-tag type="danger" v-if="scope.row.upload_settle == '2'" size="small">已撤销</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="80" align="center">
                <template #default="scope">
                  <el-link type="primary" @click="registClick(scope.row)"
                    v-if="scope.row.dict_status == '908110000' || scope.row.dict_status == '908130000' || scope.row.dict_status == '' || scope.row.dict_status == null">
                    挂号
                  </el-link>
                  <el-link type="danger" @click="caseClick(scope.row)" v-if="scope.row.dict_status == '908120000'">
                    取消
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination :currentPage="pageData2.currentPage" :page-size="pageData2.pageSize"
                :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
                :total="pageData2.totalSum" @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <viewDialog ref="viewDialogRef" @refreshDataList="getDataList()"></viewDialog>
    <guahao ref="guahao" @jsConfirm="getDataList2()"></guahao>
  </div>
</template>
<script>
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount,
    getCurrentInstance
  } from 'vue'
  import service from '@/utils/request'
  import { gitDictList, gitDictVal, TimestampToTime, downLoadXlsx } from '@/utils/tool'
  import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
  import viewDialog from '../registerList/viewDialog.vue'
  import guahao from './guahao.vue'
  export default {
    name: 'patentList',
    components: {
      viewDialog, guahao
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        searchData: {
          time: '',
          dict_department: '',
          cert_no: '',
          name: '',
          doctor_id: '',
          dict_status: '',
        },
        pageData: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        pageData2: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        dataListLoading: false,
        dataListLoading2: false,
        tableData: [],
        tableData2: [],
        dictList: {},
        searchForm: null,
        tableHei: 0,
        istable: false,
        tableBoxRef: null,
        viewDialogRef: null,
        activeName: '1',
        saveLoad: false
      })
      onMounted(() => {
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        state.istable = false
        state.tableHei = state.tableBoxRef.clientHeight - 60
        console.log(state.tableHei)
        getDoctorList()
        initData()
        nextTick(() => {
          state.istable = true
        })
        getDataList()
      })
      const typeChange = (val) => {
        console.log(val)
      }
      const handleSizeChange = (val) => {
        state.pageData.pageSize = val
        getDataList()
      }
      const handleSizeChange2 = (val) => {
        state.pageData2.pageSize = val
        getDataList2()
      }

      const handleCurrentChange = (val) => {
        state.pageData.currentPage = val
        getDataList()
      }
      const handleCurrentChange2 = (val) => {
        state.pageData2.currentPage = val
        getDataList2()
      }
      const modParient = (row)=>{
        state.saveLoad = true
        nextTick(() => {
          state.saveLoad = false
          state.viewDialogRef.initData(row.patient_id, '2', row.id, row)
        })
      }
      const initData = async () => {
        state.dictList = await gitDictList([
          '156000000',
        ])
      }
      const getDoctorList = async () => {
        let res = await service.post('/api/user/list', {
          role_id: 1,
        })
        if (res.code === 0) {
          state.dictList.duty_doctor = res.data.records
        }
      }
      const resetForm = () => {
        Object.keys(state.searchData).forEach((key) => (state.searchData[key] = ""))
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        handleSearch()
      }
      const handleSearch = () => {
        if (state.activeName == '1') {
          state.pageData.currentPage = 1
          getDataList()
        } else {
          state.pageData2.currentPage = 1
          getDataList2()
        }

      }

      const getDataList = async () => {
        state.dataListLoading = true
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1],
            current: state.pageData.currentPage,
            size: state.pageData.pageSize,
            dict_department: state.searchData.dict_department,
            cert_no: state.searchData.cert_no,
            name: state.searchData.name,
            doctor_id: state.searchData.doctor_id,
            dict_status: state.searchData.dict_status,
          }
        } else {
          data = {
            current: state.pageData.currentPage,
            size: state.pageData.pageSize,
            dict_department: state.searchData.dict_department,
            cert_no: state.searchData.cert_no,
            name: state.searchData.name,
            doctor_id: state.searchData.doctor_id,
            dict_status: state.searchData.dict_status,
          }
        }
        let res = await service.post(
          '/api/bedReg/list',
          data
        )
        state.dataListLoading = false
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData = res.data.records
            state.pageData.totalSum = res.data.total
          } else {
            state.tableData = []
            state.pageData.totalSum = 0
          }
        }
      }
      const getDataList2 = async () => {
        state.dataListLoading2 = true
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1],
            current: state.pageData2.currentPage,
            size: state.pageData2.pageSize,
            dict_department: state.searchData.dict_department,
            cert_no: state.searchData.cert_no,
            name: state.searchData.name,
            doctor_id: state.searchData.doctor_id,
            dict_status: state.searchData.dict_status,
          }
        } else {
          data = {
            current: state.pageData2.currentPage,
            size: state.pageData2.pageSize,
            dict_department: state.searchData.dict_department,
            cert_no: state.searchData.cert_no,
            name: state.searchData.name,
            doctor_id: state.searchData.doctor_id,
            dict_status: state.searchData.dict_status,
          }
        }
        let res = await service.post(
          '/api/bedReg/listNormal',
          data
        )
        state.dataListLoading2 = false
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData2 = res.data.records
            state.pageData2.totalSum = res.data.total
          } else {
            state.tableData2 = []
            state.pageData2.totalSum = 0
          }
        }
      }
      //点击挂号
      const registClick = (row) => {
        state.saveLoad = true
        nextTick(() => {
          state.saveLoad = false
          state.viewDialogRef.initData(row.patient_id, '1', row.id, row)
        })
      }
      //取消挂号
      const caseClick = (item) => {
        let url = ''
        let data = ''
        if (state.activeName == '1') {
          url = '/api/bedReg/cancel'
          data = {
            bed_reg_id: item.bed_reg_id
          }
        } else {
          url = '/api/bedReg/cancelNormal'
          data = {
            id: item.id
          }
        }
        ElMessageBox.confirm('请确认取消挂号？', '取消挂号', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await service.post(url, data)
            if (res.code === 0) {
              ElMessage.success(res.msg)
              if (state.activeName == '1') {
                getDataList()
              } else {
                getDataList2()
              }
            }
          })
          .catch(() => { })
      }
      const exportTable = (row) => {
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1],
            dict_department: state.searchData.dict_department,
            cert_no: state.searchData.cert_no,
            name: state.searchData.name,
            doctor_id: state.searchData.doctor_id,
            dict_status: state.searchData.dict_status,
          }
        } else {
          data = {
            dict_department: state.searchData.dict_department,
            cert_no: state.searchData.cert_no,
            name: state.searchData.name,
            doctor_id: state.searchData.doctor_id,
            dict_status: state.searchData.dict_status,
          }
        }
        let time = TimestampToTime()
        let title = `挂号信息${time}.xlsx`
        downLoadXlsx('/api/store_out_record/export_out_list', data, title)
      }
      function handleClick(e) {
        state.activeName = e.props.name
        handleSearch()
      }
      function addGhxx() {
        proxy.$refs.guahao.visible = true
        proxy.$refs.guahao.initData()
      }
      return {
        ...toRefs(state),
        handleSizeChange,
        typeChange,
        handleCurrentChange,
        handleSizeChange2,
        handleCurrentChange2,
        handleSearch,
        getDataList,
        getDataList2,
        resetForm,
        registClick,
        caseClick,
        getDoctorList,
        exportTable,
        handleClick,
        addGhxx,
        modParient      }
    },
  }
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 18% 20% 18% 25% 15%;
    grid-template-rows: repeat(1, 20px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 220px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 10px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {}

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .labelSet1 {
    width: 60px;
    height: 30px;
    line-height: 30px;
    display: block;
    text-align: center;
    color: #fff;
    border-radius: 5px;
  }

  .psckset {
    background-color: #409EFF;
  }

  .psckset1 {
    background-color: #a4cef8;
    color: #1581fc;
    border: 1px solid #1581fc;
  }

  .lcsyset {
    background-color: #c6f1b1;
    color: #3bb207;
    border: 1px solid #5bd324;
  }

  .lcsyset1 {
    background-color: #f1beb1;
    color: #f35c0c;
    border: 1px solid #f35c0c;
  }
</style>